import { render, staticRenderFns } from "./FallbackArrivalCard.vue?vue&type=template&id=d690d82c"
import script from "./FallbackArrivalCard.vue?vue&type=script&lang=ts"
export * from "./FallbackArrivalCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports